export default __webpack_public_path__ + "static/media/640_store01-fr-mobile.9ce0dff4.png";